var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{staticClass:"close-button",class:_vm.elClasses,nativeOn:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.close)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }